import { render, staticRenderFns } from "./PatientInfoList.vue?vue&type=template&id=3a83cd95&scoped=true&"
import script from "./PatientInfoList.vue?vue&type=script&lang=js&"
export * from "./PatientInfoList.vue?vue&type=script&lang=js&"
import style0 from "./PatientInfoList.vue?vue&type=style&index=0&id=3a83cd95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83cd95",
  null
  
)

export default component.exports